

(function () {
  'use strict';

  function getAutoScroll() {
    if (window.splide && window.splide.Extensions && window.splide.Extensions.AutoScroll) {
      return window.splide.Extensions.AutoScroll;
    }
    if (window.Splide && window.Splide.Extensions && window.Splide.Extensions.AutoScroll) {
      return window.Splide.Extensions.AutoScroll;
    }
    return null;
  }

  function mount(el) {
    if (!el || !window.Splide) return;
    if (el.__cerusSplide) {
      try { el.__cerusSplide.destroy(); } catch (e) {  }
      el.__cerusSplide = null;
    }

    var bar = el.closest('[data-cerus-announce]') || el;
    var dir = bar.dataset.direction || 'rtl';
    var speed = parseFloat(bar.dataset.speed);
    if (isNaN(speed)) speed = 0.6;
    var gap = parseInt(bar.dataset.gap, 10);
    if (isNaN(gap)) gap = 48;
    var pauseHover = bar.dataset.pauseOnHover === 'true';


    var scrollSpeed = (dir === 'ltr') ? -Math.abs(speed) : Math.abs(speed);

    var splide = new window.Splide(el, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 1,
      autoWidth: true,
      gap: gap,
      arrows: false,
      pagination: false,
      clones: 8,
      autoScroll: {
        speed: scrollSpeed,
        pauseOnHover: pauseHover,
        pauseOnFocus: false
      }
    });

    var AutoScroll = getAutoScroll();
    if (AutoScroll) {
      splide.mount({ AutoScroll: AutoScroll });
    } else {
      splide.mount();
    }
    el.__cerusSplide = splide;



    try {
      if (splide.Components && splide.Components.AutoScroll) {
        splide.Components.AutoScroll.play();
      }
    } catch (e) {  }
  }

  function unmount(el) {
    if (el && el.__cerusSplide) {
      try { el.__cerusSplide.destroy(); } catch (e) {  }
      el.__cerusSplide = null;
    }
  }

  function initAll(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-cerus-announce-splide]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-cerus-announce-splide]').forEach(unmount);
  });
})();
